import React from "react";
import { Link } from "react-router-dom";

import Footer from "../../../components/common/Footer";
import PageHeading from "../../../components/common/PageHeading";
import RightBar from "../../../components/common/RightBar";
import SubHeading from "../../../components/common/SubHeading";

import './GeneralSettings.css';

const GeneralSettingsRightBar = [];

function GeneralSettings() {
  return (
    <>
      <div className="page-container">
        <div className="main-container">
          <PageHeading heading="General Settings" />
          <div className="general-settings-links">
            <div className="links-container">
              <Link to="/generalsettings/manage-company-settings/company-settings">Manage Company Settings</Link>
              <Link to="/mysettings">Manage My Settings</Link>
              <Link to="/generalsettings">Update Billing Information</Link>
              <Link to="/generalsettings">Community Association Bank Settings</Link>
            </div>
            <div className="links-container">
              <SubHeading subHeading="Accounting" />
              <Link to="/generalsettings/accounting-settings">Manage Accounting Settings</Link>
              <Link to="/generalsettings/accounting-periods">Manage Accounting Periods</Link>
              <Link to="/generalsettings/management-fee-settings">Management Fee Settings</Link>
            </div>
            <div className="links-container">
              <SubHeading subHeading="Approvals" />
              <Link to="/generalsettings/bills-approval-flow">Manage Bill Approval Flow</Link>
            </div>
            <div className="links-container">
              <SubHeading subHeading="Users" />
              <Link to="/generalsettings/user-roles-permissions">Manage User Rolls and Permissions</Link>
              <Link to="/generalsettings/manage-users">Manage Users</Link>
              <Link to="/generalsettings/new-users">New Users</Link>
              <Link to="/generalsettings/gl-account-permissions">Manage GL Account Permissions</Link>
            </div>
            <div className="links-container">
              <SubHeading subHeading="Property Groups" />
              <Link to="/generalsettings/property-groups">Manage Property Groups</Link>
              <Link to="/generalsettings/new-property-groups">New Property Group</Link>
            </div>
            <div className="links-container">
              <SubHeading subHeading="Owners" />
              <Link to="/generalsettings/management-agreement-templates">Management Agreement Templates</Link>
            </div>
            <div className="links-container">
              <SubHeading subHeading="Leasing" />
              <Link to="/generalsettings/online-posting-settings">Online Posting Settings</Link>
              <Link to="/generalsettings/rental-application-customization">Rental Application Customization</Link>
              <Link to="/generalsettings/showings-settings">Showings Settings</Link>
              <Link to="/generalsettings/rental-application-fees">Rental Application Fees</Link>
              <Link to="/generalsettings/screening-criteria">Screening Criteria</Link>
              <Link to="/generalsettings/leasing">Screening Policies</Link>
              <Link to="/generalsettings/lease-settings">Lease Settings</Link>
              <Link to="/leasing/leases/lease-templates">Lease Templates</Link>
            </div>
            <div className="links-container">
              <SubHeading subHeading="Documents" />
              <Link to="/leasing/leases/pdf-form-templates">PDF Form Templates</Link>
            </div>
            <div className="links-container">
              <SubHeading subHeading="Maintenance" />
              <Link to="/generalsettings/maintenance/work-order-settings">Work Order Settings</Link>
              <Link to="/generalsettings/maintenance/scheduling-settings">Scheduling Settings</Link>
            </div>

            <div className="links-container">
                <SubHeading subHeading="Communication" />
                <Link to="/generalsettings/communication/automatic-communication-settings">Automatic Communication Settings</Link>
                <Link to="/generalsettings/communication/text-settings">Texting Settings</Link>
                <Link to="/generalsettings/communication">Rent and Dues Reminder Settings</Link>
                <Link to="/generalsettings/communication">Survey Settings</Link>
                <Link to="/generalsettings/communication/owner-communication-setting">Owner Settings</Link>
                <Link to="/generalsettings/communication/bulk-portal-communication">Bulk Communication Settings</Link>
            </div>
            <div className="links-container">
              <SubHeading subHeading="Tags" />
              <Link to="/generalsettings/manage-tags">Manage Tags</Link>
            </div>
          </div>
          <Footer />
        </div>
      </div>
      <div className="RightSidebar">
        <RightBar RightBarData={GeneralSettingsRightBar} />
      </div>
    </>
  );
}

export default GeneralSettings;